import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useDevLogging } from "@limitless/common/hooks/dev-logging/DevLoggingContext";
import { useAuthentication } from "./AuthenticationHook";
// Set the default state values for each context
export const AuthenticationContext = /*#__PURE__*/createContext({});

// could probably be merged with ExpertAuthenticationHook
export const AuthenticationContextProvider = ({
  children,
  disableWebSockets,
  appAccessPolicy
}) => {
  const authObj = useAuthentication(disableWebSockets, appAccessPolicy);
  const {
    stateTracker
  } = useDevLogging();
  const configContext = useMemo(() => {
    stateTracker.trackState({
      auth: authObj
    });
    return {
      ...authObj
    };
  }, [authObj.auth, authObj.areWebSocketsEnabled, authObj.isSignInActive]);
  return /*#__PURE__*/React.createElement(AuthenticationContext.Provider, {
    value: configContext
  }, children);
};
export const useAuthenticationContext = () => {
  return useContext(AuthenticationContext);
};
AuthenticationContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  disableWebSockets: PropTypes.bool.isRequired,
  appAccessPolicy: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
};